export default __webpack_public_path__ + "static/cardImg2-c6b5cecc3d7d641f885212978b6f16fc.webp";